import React from "react";
import moment from "moment";

import { IEquity, IEqSip } from "../../../../types/components/orderBook/obTypes";
import indexer, { IListObj } from "../../../../types/genericTypes";

import Tag from "../../../../generic/tag";
import OverflowButton from "../../../../generic/overflowButton";
import Sort, { sort, eSortState } from "../../../../generic/sort";
import ObCheckbox from "../../generic/obCheckbox";
import EdButton from "../../../../generic/edButton";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";

import TocNoData from "../../../generic/tocNoData/tocNoData";
import { dateTimeFormat, GetNoOfDaysOrMonths } from "../../../../service/dateTimeService"; //convert slash contained datestring to valid date with hypen separated
import obtradeRowSelection from "../../../../service/orderBook/selectAll";
import { toINR } from "../../../../service/numberFormat";
import { HObGroupBy, HOb2DGroupBy } from "../../../../service/orderBook/obGrpByHelper";
import { AEqCancelNrmTrd, AEqCancelSIPOrd, AEqCancelAmoTrd } from "../../../../service/orderBook/obApiService";

import { ChipColorKeyComb, ovrOptions, scrlStCls, ObScrollStyle, ChipStatusComb } from "../../obConstants";

import ObUtilHeader from "../../obContainer/obUtilHeader";
import DatePickerInt from "../../obContainer/obDatePickerInt";

import ObEqDtlsOpen from "../../obDetails/dsk/obEqDtlsOpen";
import ObToastMessPopup from "../../generic/obToastMessPopup";

//styles
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";
import ee from "../../../../utils/eventEmitter";

export interface IObEquityProps {
	// Array of Equity Data
	data: Array<any>;
	//true if table is history type else false
	isHistory?: boolean;
	hidePageNav?: (hide: boolean) => void;
	getDates: (frmDt: Date, toDate: Date) => void;
	isSip: boolean;
	aType: string;
	reRenderCall?: (value: string) => void;
}

// heading for equity Asset table
const heading: indexer = {
	symbol: "Symbol",
	prodType: "Prod. Type",
	ordType: "Ord. Type.",
	qty: "Qty",
	avgPrice: "Avg. Price",
	orderPrice: "Order Price"
};
const headingSip = {
	period: "Period",
	symbol: "Symbol",
	prodType: "Prod. Type",
	frequency: "Frequency",
	next: "Next",
	qty: "Qty.",
	avgPrice: "Avg. Price"
};
const sortKey: indexer = {
	symbol: "trdSym"
};
const sortKeySIP: indexer = {
	symbol: "tSym"
};

const ObEquity: React.FC<IObEquityProps> = (props) => {
	//row options start
	const ovrOpts: Array<IListObj> = ovrOptions;

	if (props.data.length && !props.isHistory) {
		for (let i = 0; i < props.data.length; i++) {
			var temp: Array<IListObj> = [];
			let dp: IEquity = props.data[i];

			if (dp.edit === "true") {
				temp.push(ovrOpts[0]);
			}
			if (dp.cancel === "true" || props.isSip) {
				temp.push(ovrOpts[1]);
			}
			if (dp.sts === "rejected") {
				temp.push(ovrOpts[3]);
			}
			if (dp.sts === "open" || (dp.sts === "pending" && dp.ogt === "AMO")) {
				temp.push(ovrOpts[2]);
			}
			if (dp.sts === "complete" || dp.sts === "completed" || dp.sts === "cancelled" || dp.sts === "cancelled after market order") {
				temp.push(ovrOpts[4]); //details
			}
			dp["ovrOpts"] = temp;
		}
	}

	//row options end

	//selection handle start
	const [isSelectEnable, setIsSelectEnable] = React.useState(false);

	const [isAllDataSelected, setIsAllDataSelected] = React.useState(false);
	//selection handle end

	//executed orders count
	const exeCountRef = React.useRef();
	//Show Open Ords on Top or not ref state
	const OpenOrdsTopRef = React.useRef<boolean>();

	// wherever initial data needs to be sent, send initialData
	// initial data is array of array for supporting grouping
	const initialData = [
		props.data.map((data: any, index: number) => ({
			...data,
			isSelected: false
		}))
	];

	// filteredData contains filtered, searched data
	const [filteredData, setFilteredData] = React.useState<Array<Array<{}>>>(initialData);
	// let filteredData: Array<Array<{}>> = initialData;

	// tableData is shown in the table
	// tableData contains sorted, filtered, searched data
	const [tableData, setTableData] = React.useState<Array<Array<{}>>>([]);
	let eqHistoryData: Array<{ [x: string]: Array<IEquity> }> = [{}];

	React.useEffect(() => {
		setTableData([props.data]);
		//ref to initial toggle state of show open orders on top
		OpenOrdsTopRef.current = true;
		// check that props.data is not undefined/null, group it(open and others) and update tabledata
		// ee.emit("showToast", { message: `Cancelled ${0} Orders`, color: "cancell" });

		if (props.data.length) {
			if (!props.isHistory && !props.isSip && OpenOrdsTopRef.current) {
				let temp0 = HOb2DGroupBy(props.data, "sts");
				exeCountRef.current = temp0[1].length;
				setTableData(temp0);
			}
		}

		return () => {
			setTableData([[{}]]);
		};
	}, [props.data, props.isHistory, props.isSip]);

	//kept outside because state data updating in async mode
	if (props.isHistory && props.data.length) {
		eqHistoryData = tableData.map((group) => HObGroupBy(group, "ordEntTyp", " "));
	}
	const [sortedColumnState, setSortedColumnState] = React.useState({ colName: null as string | null, sortState: eSortState.ASC });

	//selected count
	const [selectedCount, setselectedCount] = React.useState<number>(0);

	//is popup data
	const [popupDataIndex, setPopupDataIndex] = React.useState<[number | string, number, string?]>();

	// show cancel popup
	const [showCancelPopup, setShowCancelPopup] = React.useState<{ bulkCancel: boolean; data?: any }>();

	function onSort(data: Array<Array<any>>, sortState: eSortState) {
		setSortedColumnState({ colName: heading.symbol, sortState: sortState });
		setTableData(data);
		OpenOrdsTopRef.current = false;
	}

	const selectRows = (groupIndex: number, index: number) => {
		const retRes = obtradeRowSelection(groupIndex, index, tableData, isAllDataSelected, "cancel", "true");

		// set the state
		setTableData(retRes.data);
		setselectedCount(retRes.count);

		setIsAllDataSelected(retRes.allSelected);
	};
	//called on filter and search
	function onDataFilter(data: Array<any>, sText?: string, type?: string) {
		setFilteredData(data);
		// filteredData = data;

		// sort only if colName is present, otherwise there is no need to sort
		if (sortedColumnState.colName) {
			const colNameKey = Object.keys(heading).find((key) => heading[key] === sortedColumnState.colName)!;
			sort(data, sortedColumnState.sortState, sortKey[colNameKey], onSort);
		}
		//highlightes the search text
		if (sText) {
			const SearchText: string = sText.toLowerCase();
			const searchKeys: string = "cpName;dpName;symName;trdSym;tSym";

			data[0].forEach((ord: indexer) => {
				searchKeys.split(";").forEach((k: string) => {
					if (ord[k]) {
						ord[k] = SearchHighLight(ord[k], SearchText);
					}
				});
			});
		}
		if (type === "search" && OpenOrdsTopRef.current && !props.isHistory && !props.isSip) {
			setTableData(HOb2DGroupBy(data[0], "sts"));
		} else {
			setTableData(data);
		}
	}
	//overflow option selection
	function optSelection(
		id: string | number,
		data: {
			gI: number;
			ind: number;
			ordData: indexer;
		}
	) {
		id = typeof id === "string" ? id.toLowerCase() : id;
		switch (id) {
			case "details":
			case "convert":
				//onRowClick was replace with setPopupDataIndex, overflow menu included in path block logic written in onrowclick
				setPopupDataIndex([data.gI, data.ind]);
				break;
			case "cancel":
				checkPartialOrder(false, data.ordData as IEquity);
				break;

			default:
				console.log("404");
				break;
		}
	}

	// this function excute on clicking any row
	// date is passed only in the case of history
	function onRowClick(data: any, groupIndex: number | string, index: number, e?: any) {
		//each row contains two different native events, one of overflow and other is of checkbox
		if (
			e &&
			!e.nativeEvent.path.find((m: HTMLElement) => m.className && (m.className.indexOf("check") >= 0 || m.className.indexOf("menu") >= 0))
		) {
			setPopupDataIndex([groupIndex, index]);
		}
	}

	function addFlAndNtQty(bulkCancel: boolean, data?: IEquity) {
		let flQtySum = 0;
		let ntQtySum = 0;

		if (bulkCancel) {
			tableData.forEach((g: any) =>
				g.forEach((rw: IEquity) => {
					if (rw.isSelected) {
						flQtySum += +rw.flQty;
						ntQtySum += +(rw.ntQty ? rw.ntQty : rw.qtyTF || 0);
					}
				})
			);
		} else if (data) {
			flQtySum += +data.flQty;
			ntQtySum += +(data.ntQty ? data.ntQty : data.qtyTF || 0);
		}

		return { flQtySum, ntQtySum };
	}

	function selectedRows(bulkCancel: boolean, data?: IEquity) {
		if (bulkCancel) {
			let total = 0;
			tableData.forEach((g: any) =>
				g.forEach((rw: IEquity) => {
					if (rw.isSelected) {
						total++;
					}
				})
			);
			return total;
		} else if (data) {
			return 1;
		}
		return 0;
	}

	let ordCancelledSuccList: Array<string> = [],
		ordCancelledFailList: Array<string> = [],
		ordsListToCancel: Array<string> = [];

	// runs after all cancel api response
	function cancelCallback(res: any) {
		if (res.data) {
			// if success
			ordCancelledSuccList.push(res.data);
		} else {
			// if error
			ordCancelledFailList.push(res.error);
		}

		// when we get all the responses
		if (ordCancelledSuccList.length + ordCancelledFailList.length === ordsListToCancel.length) {
			setShowCancelPopup(undefined); // close confirmation popup
			//show toast message
			ee.emit("showToast", { message: `Cancelled ${ordsListToCancel.length} Orders`, color: "cancell" });
			props.reRenderCall && props.reRenderCall("today");
		}
	}

	function checkPartialOrder(bulkCancel: boolean, data?: IEquity) {
		// <span>{data.flQty}</span>/<span>{data.ntQty ? data.ntQty : data.qtyTF}</span>
		const { flQtySum, ntQtySum } = addFlAndNtQty(bulkCancel, data);

		if (flQtySum === ntQtySum) {
			// not partially completed
			cancelOrder(bulkCancel, data);
		} else {
			// partially completed
			setShowCancelPopup({ bulkCancel, data });
		}
	}

	function cancelOrder(bulkCancel: boolean, data?: any) {
		if (bulkCancel) {
			tableData.forEach((g: any) =>
				g.forEach((rw: IEquity) => {
					if (rw.isSelected) {
						ordsListToCancel.push(rw.ordID);
						if (props.isSip) {
							// if sip trade then run this api
							AEqCancelSIPOrd(cancelCallback, rw.ordID);
						} else if (rw.ogt === "AMO") {
							// if amo trade then run this api
							AEqCancelAmoTrd(cancelCallback, { nstOID: rw.ordID, exc: rw.exc, ordTyp: rw.ordTyp, prdCode: rw.prdCode });
						} else {
							// if normal trade then run this api
							AEqCancelNrmTrd(cancelCallback, { nstOID: rw.ordID, exc: rw.exc, ordTyp: rw.ordTyp, prdCode: rw.prdCode });
						}
					}
				})
			);
		} else if (data) {
			// cancel single order
			ordsListToCancel.push(data?.ordID);
			if (props.isSip) {
				// if sip trade then run this api
				AEqCancelSIPOrd(cancelCallback, data.ordID);
			} else if (data.ogt === "AMO") {
				// if amo trade then run this api
				AEqCancelAmoTrd(cancelCallback, { nstOID: data.ordID, exc: data.exc, ordTyp: data.ordTyp, prdCode: data.prdCode });
			} else {
				// if normal trade then run this api
				AEqCancelNrmTrd(cancelCallback, { nstOID: data.ordID, exc: data.exc, ordTyp: data.ordTyp, prdCode: data.prdCode });
			}
		}
	}

	function eqRow(data: IEquity, groupIndex: number | string, index: number) {
		return (
			<li
				key={index}
				className={(props.aType === "equity" ? "eq_data " : props.aType === "derivative" ? "der_data " : "curncy_data ") + " ins_data"}
				onClick={(e) => onRowClick(data, groupIndex, index, e)}
			>
				{isSelectEnable && (
					<div className="col check">
						{data.ovrOpts && data.cancel === "true" && (
							<ObCheckbox name="eqTradeSelect" checked={data.isSelected} onChange={() => selectRows(groupIndex as number, index)} />
						)}
					</div>
				)}
				<div className="col time">
					<span>
						{data.rcvTim && data.rcvTim}
						{data.ordEntTyp && moment(dateTimeFormat(data.ordEntTyp)).format("HH:mm:ss")}
					</span>
				</div>
				<div className="col txn_typ">
					<span>
						{data.trsTyp && (
							<Tag
								value={data.trsTyp[0]}
								shape="mini_circle"
								color={data.trsTyp === "BUY" ? "green" : "red"}
								height="22px"
								width="22px"
							/>
						)}
					</span>
				</div>
				<div className="col sym">
					{props.aType === "equity" && (
						<span dangerouslySetInnerHTML={{ __html: data.cpName ? data.cpName : data.dpName ? data.dpName : data.trdSym }}></span>
					)}
					{props.aType !== "equity" && (
						<>
							<p dangerouslySetInnerHTML={{ __html: data.symName ? data.symName : data.cpName ? data.cpName : data.dpName }}></p>
							<p className="sym_code" dangerouslySetInnerHTML={{ __html: data.trdSym }}></p>
						</>
					)}
				</div>
				<div className="col prod_typ">
					<span>{data.prdCode}</span>
				</div>
				{props.aType === "equity" && (
					<div className="col ord_typ">
						<span>{data.ordTyp}</span>
					</div>
				)}
				<div className="col qty taRight">
					<span>{data.flQty}</span>/<span>{data.ntQty ? data.ntQty : data.qtyTF}</span>
				</div>
				<div className="col avg_prc taRight">
					<span>{toINR(data.avgPrc, 2)}</span>
				</div>
				{props.aType === "currency" && <div className="col odr_prc taRight">{toINR(data.prc, 2)}</div>}

				{!props.isHistory && (
					<div className="col amo">
						<span>{data.ogt && data.ogt !== "--" ? data.ogt : ""}</span>
					</div>
				)}
				<div className="col sts">
					<span>
						{data.sts && (
							<Tag
								value={
									data.ogt && ChipStatusComb[data.sts.toLowerCase()] === "amo" && data.ogt !== "--"
										? "--"
										: ChipStatusComb[data.sts.toLowerCase()]
								}
								shape="chip"
								color={ChipColorKeyComb[data.sts?.toLowerCase()]}
							/>
						)}
					</span>
				</div>
				{!isSelectEnable && !props.isHistory && (
					<div className="col menu">
						<OverflowButton
							defaultValue={"modify"}
							dropdownOptions={data.ovrOpts ? data.ovrOpts : []}
							onSelect={(id, data) => optSelection(id, data)}
							onHover={true}
							data={{
								ordData: data,
								gI: groupIndex,
								ind: index
							}}
						/>
					</div>
				)}
			</li>
		);
	}

	function nonSIP() {
		return (
			<>
				<div
					className={
						(props.aType === "equity" ? "eq_table " : props.aType === "derivative" ? "der_table " : "curncy_table ") +
						" ins_tabl" +
						(props.isHistory ? " history" : "")
					}
				>
					{/* ob Equity Header Row */}
					{(!props.isHistory || (props.isHistory && initialData[0].length > 0)) && (
						<ul className={scrlStCls.pOffset + " hdr_row list-unstyled"}>
							<li>
								{isSelectEnable && (
									<div className="col check">
										<ObCheckbox name="eqTradeSelect" checked={isAllDataSelected} onChange={() => selectRows(-1, -1)} />
									</div>
								)}
								<div className="col time"> </div>
								<div className="col txn_typ"> </div>
								<div className="col sym">
									{!props.isHistory && (
										<Sort
											sortList={filteredData}
											sortedColName={sortedColumnState.colName}
											sortKey={sortKey.symbol}
											onSort={onSort}
											colName={heading.symbol}
										/>
									)}
									{props.isHistory && heading.symbol}
								</div>
								<div className="col prod_typ">{heading.prodType}</div>
								{props.aType === "equity" && <div className="col ord_typ">{heading.ordType}</div>}
								<div className="col qty taRight">{heading.qty}</div>
								{props.aType === "currency" && <div className="col odr_prc taRight">{heading.orderPrice}</div>}

								<div className="col avg_prc taRight">{heading.avgPrice}</div>

								{!props.isHistory && <div className="col amo"> </div>}
								<div className="col sts"> </div>
								{!isSelectEnable && !props.isHistory && <div className="col menu"> </div>}
							</li>
						</ul>
					)}
					<div className={props.data.length > 0 ? "ObScrollCont" : ""} style={ObScrollStyle(props.data.length > 0 ? true : false)}>
						{props.isHistory ? (
							eqHistoryData.map((group, groupIndex) =>
								Object.keys(group).map((date, index) => {
									return (
										<React.Fragment key={index}>
											<ul className={scrlStCls.freeze + " eq_hist_date hist_date"} key={"dtGp" + index}>
												<li>{moment(dateTimeFormat(date)).format("DD MMMM YYYY")}</li>
											</ul>
											<ul className={scrlStCls.toContext} key={"dtUlDet" + index}>
												{group[date].map((row: any, index: number) => eqRow(row, date, index))}
											</ul>
										</React.Fragment>
									);
								})
							)
						) : (
							<>
								{
									!!tableData.length &&
										tableData.map((group: any, groupIndex: number) =>
											// Object.keys(group).map((grp: any, index) =>
											{
												return (
													<React.Fragment key={groupIndex}>
														{group.length > 0 && (
															<ul key={groupIndex} className={"blockDivider child" + groupIndex}>
																{group.map((row: any, index: number) => (
																	<React.Fragment key={index}>{eqRow(row, groupIndex, index)}</React.Fragment>
																))}
															</ul>
														)}
													</React.Fragment>
												);
											}
										)
									// )
								}
							</>
						)}
					</div>
				</div>
			</>
		);
	}

	function sipOrders() {
		return (
			<div className="sip_type1_table ins_tabl">
				{/* ob  SIP Header Row */}

				<ul className="hdr_row">
					<li>
						<div className="col period">{headingSip.period}</div>
						<div className="col sym">
							<Sort
								sortList={filteredData}
								sortedColName={sortedColumnState.colName}
								sortKey={sortKeySIP.symbol}
								onSort={onSort}
								colName={headingSip.symbol}
							/>
						</div>
						<div className="col prod_typ">{headingSip.prodType}</div>
						<div className="col freqc">{headingSip.frequency}</div>
						<div className="col next">{headingSip.next}</div>
						<div className="col qty taRight">{headingSip.qty}</div>
						<div className="col avg_prc taRight">{headingSip.avgPrice}</div>
						<div className="col sts"> </div>
						<div className="col menu"></div>
					</li>
				</ul>

				{/* ob  SIP content Row */}

				{
					!!tableData.length &&
						tableData.map((group: any, groupIndex: number) =>
							// Object.keys(group).map((grp: any, index) =>
							{
								return (
									<ul
										className={props.data.length > 0 ? "ObScrollCont" : ""}
										style={ObScrollStyle(props.data.length > 0 ? true : false)}
										key={groupIndex}
									>
										{group.map((item: IEqSip, index: number) => (
											<React.Fragment key={index}>
												<li className="sip_type1_data ins_data">
													<div className="col period">
														<span className="per1">{moment(dateTimeFormat(item.spSD)).format("DD MMM ‘YY")}</span>
														<span className="per1">{moment(dateTimeFormat(item.spLED)).format("DD MMM ‘YY")}</span>
													</div>
													<div className="col sym">
														<span dangerouslySetInnerHTML={{ __html: item.tSym }}></span>
													</div>
													<div className="col prod_typ">
														<span>{item.pCode}</span>
													</div>
													<div className="col freqc">
														<span className="tCC">
															{item.sFrqy} ({GetNoOfDaysOrMonths(item.spNDD, item.spSD, item.sFrqy.toLowerCase())}/
															{GetNoOfDaysOrMonths(item.spLED, item.spSD, item.sFrqy.toLowerCase())})
														</span>
													</div>
													<div className="col next">
														<span>{moment(dateTimeFormat(item.spNDD)).format("DD MMM YY")}</span>
													</div>
													<div className="col qty taRight">
														<span>{item.spQty}</span>
													</div>
													<div className="col avg_prc taRight">
														<span>{item.spAmt ? "₹" + toINR(item.spAmt, 0) : "--"}</span>
													</div>
													<div className="col sts">
														<span>--</span>
													</div>
													<div className="col menu">
														{item.ovrOpts && (
															<OverflowButton
																defaultValue={"modify"}
																dropdownOptions={item.ovrOpts && item.ovrOpts}
																onSelect={optSelection}
																onHover={true}
																data={{
																	ordData: item,
																	gI: groupIndex,
																	ind: index
																}}
															/>
														)}
													</div>
												</li>
											</React.Fragment>
										))}
									</ul>
								);
							}
						)
					// )
				}
			</div>
		);
	}

	return (
		<>
			{!isSelectEnable && (
				<ObUtilHeader
					leftSideText={
						!props.isHistory ? (
							<div className="executed">
								<span className="text">{props.isSip ? "Active SIPs" : "Executed Orders"}: </span>
								<span className="value">
									{!props.isSip ? exeCountRef.current + " /" : ""} {initialData[0].length}
								</span>
							</div>
						) : props.isHistory ? (
							<DatePickerInt plusDays={15} sendDates={props.getDates} />
						) : (
							<></>
						)
					}
					data={initialData}
					searchKey="cpName;dpName;symName;trdSym;tSym"
					onDataFilter={onDataFilter}
					onSelectClick={
						!props.isHistory && !props.isSip && tableData.find((g: any) => g.find((row: IEquity) => row.cancel === "true"))
							? () => {
									setIsSelectEnable(true);
									// props.hidePageNav && props.hidePageNav(true);
							  }
							: undefined
					}
					onFilterClick={(tgl) => {
						OpenOrdsTopRef.current = tgl;
					}}
					filterReqData={{
						status: "sts",
						aType: props.aType,
						showOpenOrderOnTop: OpenOrdsTopRef.current,
						showOpenOrderTgl: props.isHistory || props.isSip ? false : true,
						isHistory: props.isHistory ? true : false
					}}
					onSearchClick={(e) => {
						// setTableData(initialData);
						// if exists, then call it
						props.hidePageNav && props.hidePageNav(e);
					}}
				/>
			)}
			{/* //after clicking on select to show cancel orders and selectRows count */}
			{isSelectEnable && (
				<>
					<div className="util_cont util_select by2 mg-b30">
						<div className="vMid">
							<p className="selectedCount">{selectedCount} selected</p>
						</div>
						<div className="vMid taRight">
							<EdButton
								type="button"
								btnTyp="primary"
								value="Cancel Orders"
								slim={true}
								disabled={selectedCount === 0 ? true : false}
								onClick={() => checkPartialOrder(true)}
							/>
							<button onClick={() => setIsSelectEnable(false)} className="mg-l15 clsBtn edBtn">
								Close
							</button>
						</div>
					</div>
				</>
			)}

			{!props.isSip && nonSIP()}
			{props.isSip && sipOrders()}
			{!tableData.length && <TocNoData data={initialData} callBackMeth={onDataFilter} />}

			{/* tableData[groupIndex][index] */}
			{popupDataIndex && (
				<ObAssetDetailPopup>
					<ObEqDtlsOpen
						data={
							props.isHistory
								? eqHistoryData[0][popupDataIndex[0]][popupDataIndex[1]]
								: tableData[popupDataIndex[0] as number][popupDataIndex[1]]
						}
						onBackClick={() => setPopupDataIndex(undefined)}
						isTodayOrder={!props.isHistory && !props.isSip}
						onCancelClick={() => checkPartialOrder(false, tableData[popupDataIndex[0] as number][popupDataIndex[1]] as IEquity)}
					/>
				</ObAssetDetailPopup>
			)}
			{showCancelPopup && (
				<ObAssetDetailPopup>
					<ObToastMessPopup
						title={`Cancel ${selectedRows(showCancelPopup.bulkCancel, showCancelPopup.data)} Orders`}
						subtitle={
							showCancelPopup.data.dur === "GTC" || showCancelPopup.data.dur === "GTD"
								? "This will also cancel the GTD/GTC order, are you sure you want to cancel order ?"
								: `${addFlAndNtQty(showCancelPopup.bulkCancel, showCancelPopup.data).flQtySum}/${
										addFlAndNtQty(showCancelPopup.bulkCancel, showCancelPopup.data).ntQtySum
								  } quantities have been partially executed. Are you sure you want to cancel the order?`
						}
						buttonValue="Yes, Confirm"
						btnTyp="secondary"
						onBackClick={() => setShowCancelPopup(undefined)}
						onToastBtnClick={() => cancelOrder(showCancelPopup.bulkCancel, showCancelPopup.data)}
					/>
				</ObAssetDetailPopup>
			)}
		</>
	);
};

export default ObEquity;
